import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {TargetService} from './target.service';
import {loadTargets, targetsLoaded} from './target.state';
import {errorHappened, userSet} from '../app.types';
import {Store} from '@ngrx/store';
import {selectPartnerId} from '../user/user.reducer';
import {of} from 'rxjs';


@Injectable()
export class TargetEffects {
  load$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadTargets, userSet),
      withLatestFrom(this.store.select(selectPartnerId)),
      filter(([_, partnerId]) => partnerId !== undefined),
      switchMap(_ => {
        return this.client.getAllTargets()
          .pipe(
            map(result => targetsLoaded({targets: result})),
            catchError(err => of(errorHappened({error: {message: err.message}}))));
      })
    ));

  constructor(private actions$: Actions, private client: TargetService, private store: Store) {
  }
}
